import { Analytics } from 'context/analytics';

import { fireTrackEvent } from './helpers';

export const logViewedRequestAuctionEnded = (analytics: Analytics) => {
  fireTrackEvent(analytics, 'Viewed PurchaseRequestPromptAuctionEnded', {});
};
